<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<sf-card class="p-0 border-0 bg-transparent h-100">
			<table-container ref="table" @close="close" :scrId="scrId" />
		</sf-card>
		<template v-slot:footer>
			<sf-button class="btn-class-1" :onClick="close">{{ getMessage_('SWCC000113') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
import TableContainer from './Table/TableContainer.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { TableContainer },
	data() {
		return {
			show: false
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('SWCC000432'); // 공통 코드 권한 목록
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open() {
			if (this.searchParams.groupId == null || this.searchParams.screenId == null) {
				// title 선택한 정보가 없습니다.
				// message 사용자 권한 그룹 / 메뉴 목록을 선택해주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000436') });
				return;
			}
			this.show = true;
		},
		close(param) {
			if (param != undefined && param.commCd != undefined && param.commCd != null) {
				this.$emit('SetData', param);
			}
			this.show = false;
		}
	}
};
</script>
<style></style>
